import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText} from '@mui/material';
import { Link } from "react-router-dom";

export function SaveAlert({open=true, onClose, onYes, heading, message, linkTo}) {

  return (
    <div className='Dialog'>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ display:'flex', alignItems:'center', justifyContent:'center',
          }}
      >
        <DialogTitle id="alert-dialog-title">
          {heading}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {typeof message === "function" ? message() : message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} style={{color:'rgb(28, 68, 179)'}}>No</Button>
          {linkTo ? 
          <Button component={Link} to={`/`} 
          onClick={onYes} autoFocus variant='contained' style={{color: 'white', backgroundColor: 'rgb(28, 68, 179)'}}>
            Yes
          </Button> :
          <Button
          onClick={onYes} autoFocus variant='contained' style={{color: 'white', backgroundColor: 'rgb(28, 68, 179)'}}>
            Yes
          </Button>
          }
          
        </DialogActions>
      </Dialog>
    </div>
  );
}